export default "__VITE_ASSET__BwWEalm9__"